// Copy button for offer 3 (same behaviour as copy-button / copy-button1)
var copyButton2 = document.getElementById('copy-button2');

if (copyButton2) {
  copyButton2.addEventListener('click', function () {
    // Get the text to copy
    const textToCopy = document.getElementById('text-to-copy2').innerText;

    // Create a temporary textarea element
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = textToCopy;

    // Add it to the DOM
    document.body.appendChild(tempTextArea);

    // Select the text
    tempTextArea.select();
    tempTextArea.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text
    document.execCommand('copy');

    // Remove the temporary element
    document.body.removeChild(tempTextArea);

    // Optional: Provide feedback to the user
    alert('Copied to clipboard!');
  });
}